"use client";

import React from "react";
import { ShoppingBag, RotateCcw, Droplets, Truck, Warehouse, Printer, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const categories = [{
  title: "Mieten",
  description: "Flexible Mietlösungen für Events jeder Größe.",
  icon: RotateCcw,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650013/img/category_image.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650013/img/category_image.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650013/img/category_image.png-wvc-sizes",
  link: "/ShopPage"
}, {
  title: "Kaufen",
  description: "Hochwertige Mehrwegbecher für den dauerhaften Einsatz.",
  icon: ShoppingBag,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650013/img/ChatGPT Image 27. Apr. 2026, 18_37_11.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650013/img/ChatGPT Image 27. Apr. 2026, 18_37_11.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650013/img/ChatGPT Image 27. Apr. 2026, 18_37_11.png-wvc-sizes",
  link: "/ShopPage"
}, {
  title: "Reinigung",
  description: "Professionelle Spülservice nach höchsten Hygienestandards.",
  icon: Droplets,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650013/img/6.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650013/img/6.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650013/img/6.png-wvc-sizes",
  link: "/ServicesPage"
}, {
  title: "Lieferung",
  description: "Pünktliche Logistik direkt zu Ihrem Veranstaltungsort.",
  icon: Truck,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650013/img/3.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650013/img/3.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650013/img/3.png-wvc-sizes",
  link: "/ServicesPage"
}, {
  title: "Lagerung",
  description: "Sichere Einlagerung Ihrer Becherbestände.",
  icon: Warehouse,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650013/img/storage_service_category.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650013/img/storage_service_category.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650013/img/storage_service_category.png-wvc-sizes",
  link: "/ServicesPage"
}, {
  title: "Individueller Druck",
  description: "Personalisieren Sie Ihre Becher mit Ihrem Logo.",
  icon: Printer,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650013/img/ChatGPT Image 4. Mai 2026, 09_03_16.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650013/img/ChatGPT Image 4. Mai 2026, 09_03_16.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650013/img/ChatGPT Image 4. Mai 2026, 09_03_16.png-wvc-sizes",
  link: "/ServicesPage"
}];
export default function CategoryCatalog() {
  return <section className="py-24 bg-background" id="categories">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-foreground tracking-tighter mb-6">
            Unsere Leistungen im Überblick
          </h2>
          <p className="text-lg text-muted-foreground leading-relaxed">
            Von der Vermietung bis zur professionellen Reinigung – wir bieten Ihnen ein 
            Rundum-Sorglos-Paket für Ihre nachhaltige Veranstaltung in Kärnten.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {categories.map((category, i) => <div key={i} data-index={i} className="group relative overflow-hidden rounded-lg border border-border bg-card transition-all duration-300 hover:shadow-xl hover:-translate-y-1">
              <div className="aspect-video overflow-hidden">
                <img src={category.image} data-wvc-srcset={category.srcset} data-wvc-sizes={category.sizes} alt={category.title} loading="lazy" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
              </div>
              
              <div className="p-8">
                <div className="flex items-center gap-3 mb-4">
                  <div className="p-2 rounded-md bg-primary/10 text-primary">
                    <category.icon size={24} />
                  </div>
                  <h3 className="text-2xl font-bold text-foreground">
                    {category.title}
                  </h3>
                </div>
                
                <p className="text-muted-foreground mb-8 leading-relaxed">
                  {category.description}
                </p>
                
                <Button asChild variant="outline" className="rounded-full group/btn">
                  <Link to={category.link} className="flex items-center gap-2">
                    Mehr erfahren
                    <ArrowRight size={16} className="transition-transform group-hover/btn:translate-x-1" />
                  </Link>
                </Button>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}